import { bridgeCall, inPc } from '../base/bridge';
import { openPageByUrl } from '../base/router';
import { genUrl } from '../utils/query';
import { uuidv4 } from '../utils/uuid';

let __client_id__ = uuidv4();

function print(params, preview) {
    return new Promise((resolve, reject) => {
        if (preview) {
            let targetUrl = genUrl("./print-index.html#/home", Object.assign({
                __bizId__: "print-preview",
                __key__: "print"
            }, params));
            openPageByUrl(targetUrl, true, 'width=900,height=800');
            resolve();
        } else {
            if (!inPc()) {
                let targetUrl = genUrl("./print-index.html#/home", Object.assign({
                    autoPrint: true
                }, params));
                openPageByUrl(targetUrl, true, 'width=900,height=800');
                resolve();
                return;
            }
            bridgeCall("postPrintPreview", {
                clientId: getClientId(),
                params: Object.assign({
                }, params)
            }, (event) => {
                if (event && event.result) {
                    resolve();
                } else {
                    reject(event.data);
                }
            }).catch((err) => {
                reject(err);
            })
        }
    });
}

export function getClientId() {
    return __client_id__;
}

export function printInventory(inventoryInfo, printSetting) {
    return print({
        type: "inventory",
        guid: inventoryInfo.guid,
    }, printSetting);
}

export function printOrder(orderInfo, printSetting) {
    return print({
        type: "order",
        guid: orderInfo.guid,
    }, printSetting);
}
